import React, { createContext, useReducer } from 'react';
import entityRecommendationReducer from './EntityRecommendationReducer';
import * as api from '../../API/Recommendation/EntityRecommendation';
import { getCurrentSubscriptionForOrganisation } from '../../API/Payment/Payment';

export const initialState = {
    loading: true,
    entitiesLoaded: false,
    relationsLoaded: false,
    showNoEntitiesMessage: false,
    isColdStart: false,
    isShowMoreOptionVisible: true,
    showLibraryAttributes: true,
    showOrganizationAttributes: true,
    creatingData: false,
    data: [],
    relations: [],
    selectedEntities: {},
    selectedAttributes: {}
}

const subscriptionApi = {
    getCurrentSubscriptionForOrganisation
}

const EntityRecommendationContext = createContext(initialState);

export function EntityRecommendationContextProvider({ children }) {

    const [state, dispatch] = useReducer(entityRecommendationReducer, initialState)

    return (
        <EntityRecommendationContext.Provider
            value={{
                api,
                subscriptionApi,
                state,
                dispatch,
            }}>
            {children}
        </EntityRecommendationContext.Provider>
    )
}

export default EntityRecommendationContext;